import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Menu from "../menu/Menu";
import "./Postdetail.css";

import CommentPopup from "./commentpopup/CommentPopup";

export default function PostDetail() {
  useEffect(() => {
    document.title = "splash overflow | Post";
  }, []);

  const { id } = useParams();
  const [postData, setPostData] = useState(null);
  const [error, setError] = useState(null);
  const [showTexts, setShowTexts] = useState({});
  const [popupOpen, setPopupOpen] = useState(false);
  const [clickData, setClickData] = useState({ imageId: null, x: 0, y: 0 });
  const [user, setUser] = useState(null);
  const [showMarkers, setShowMarkers] = useState(true);
  const [shareNotification, setShareNotification] = useState(false);

  const [beschreibungVisible, setBeschreibungVisible] = useState(true);

  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setFullscreenOpen(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const toggleFullscreen = () => {
    setFullscreenOpen(true);
  };

  const API_URL = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const location = useLocation();

  const navigateToLogin = () => {
    navigate("/login", { state: { from: location } });
  };

  useEffect(() => {
    fetch(`${API_URL}/api/me`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        data && setUser(data);
      });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/api/posts/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Post konnte nicht geladen werden");
        return res.json();
      })
      .then((data) => {
        setPostData(data);
        const initialShowTexts = {};
        data.content?.forEach((_, index) => {
          initialShowTexts[index] = { before: true, after: true };
        });
        setShowTexts(initialShowTexts);
      })
      .catch((err) => setError(err.message));
  }, [id]);

  const toggleText = (index, position) => {
    setShowTexts((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [position]: !prev[index]?.[position],
      },
    }));
  };

  const handleImageClick = (index, e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setClickData({ imageId: index, x, y });
    setPopupOpen(true);
  };

  const handleCommentSubmit = async ({ imageId, user_id, x, y, parts }) => {
    try {
      const response = await fetch(`${API_URL}/api/comments`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          postContentId: imageId,
          userId: user?.userId,
          x,
          y,
          parts,
        }),
      });

      if (!response.ok)
        throw new Error("Kommentar konnte nicht gespeichert werden");
      window.location.reload();
    } catch (err) {
      console.error("Fehler beim Speichern des Kommentars:", err);
    }
  };

  const handleDownloadImages = () => {
    if (!window.confirm("Möchtest du alle gezeigten Bilder herunterladen?"))
      return;

    postData?.content?.forEach((c, index) => {
      const link = document.createElement("a");
      link.href = c.image_url;
      link.download = `image_${index + 1}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleShare = () => {
    const url = window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          alert("Link wurde in die Zwischenablage kopiert:\n\n" + url);
        })
        .catch((err) => {
          console.error("Fehler beim Kopieren:", err);
          alert("Hier ist der Link zum Teilen:\n\n" + url);
        });
    } else {
      alert("Kopiere diesen Link manuell:\n\n" + url);
    }
  };

  const toggleMarkers = () => {
    setShowMarkers((prev) => !prev);
  };

  if (error) return <div>Fehler: {error}</div>;
  if (!postData) return <div>Lade Post...</div>;

  const { post, content = [], uploads = [], comments } = postData;

  const handleDownloadAttachments = () => {
    if (!window.confirm("Möchtest du alle Anhänge herunterladen?")) return;
    if (!uploads.length) {
      alert("Keine Anhänge vorhanden.");
      return;
    }

    uploads.forEach((file, index) => {
      const link = document.createElement("a");
      link.href = file.file_url;
      link.download = file.file_name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const res = await fetch(`${API_URL}/api/comments/${commentId}`, {
        method: "DELETE",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Kommentar konnte nicht gelöscht werden.");
      window.location.reload();
    } catch (err) {
      console.error("Fehler beim Löschen des Kommentars:", err);
    }
  };

  function formatCommentDate(created_at) {
    const createdDate = new Date(created_at);
    const now = new Date();
    const diffMs = now - createdDate;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

    if (diffHours < 24) {
      return ` geschrieben vor ${diffHours} Stunde${
        diffHours !== 1 ? "n" : ""
      }`;
    } else {
      const diffDays = Math.floor(diffHours / 24);
      return ` geschrieben vor ${diffDays} Tag${diffDays !== 1 ? "en" : ""}`;
    }
  }

  const toggleBeschreibung = () => {
    setBeschreibungVisible((prev) => !prev);
  };

  return (
    <>
      <div>
        <Menu user={user} setUser={setUser} />
        <div className="postdetails flex">
          <div className="imageBox">
            {content.map((c, index) => (
              <div key={index} className="flex flex-column">
                {c.text_before !== "" && (
                  <div className="textBackground flex flex-column">
                    <div
                      className="textVisabilityButton align-center"
                      onClick={() => toggleText(index, "before")}
                    ></div>
                    {showTexts[index]?.before && (
                      <>
                        <div
                          className="textImages inter"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {c.text_before}
                        </div>
                        <div
                          className="textVisabilityButton align-center"
                          onClick={() => toggleText(index, "before")}
                        ></div>
                      </>
                    )}
                  </div>
                )}

                <div
                  className="imageContainer flex flex-column"
                  style={{ position: "relative" }}
                >
                  <img
                    src={c.image_url}
                    alt=""
                    style={{ maxWidth: "50em", cursor: "crosshair" }}
                    onClick={(e) => handleImageClick(c.id ?? index, e)}
                  />

                  {showMarkers &&
                    comments
                      .filter(
                        (comment) =>
                          comment.post_id === c.id &&
                          comment.x > 0 &&
                          comment.y > 0
                      )
                      .map((comment) => (
                        <div
                          key={`marker-${comment.comment_id}`}
                          className="comment-marker"
                          data-marker-id={`marker-${comment.comment_id}`}
                          onClick={() => {
                            const el = document.getElementById(
                              `comment-${comment.comment_id}`
                            );
                            if (el) {
                              el.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                              });
                              el.classList.add("comment-highlight");
                              setTimeout(() => {
                                el.classList.remove("comment-highlight");
                              }, 2000);
                            }
                          }}
                          style={{
                            position: "absolute",
                            top: `${comment.y}%`,
                            left: `${comment.x}%`,
                            width: "16px",
                            height: "16px",
                            borderRadius: "50%",
                            transform: "translate(-50%, -50%)",
                            cursor: "pointer",
                            zIndex: 10,
                          }}
                          title={`Kommentar von ${comment.username}`}
                        />
                      ))}
                </div>

                {c.text_after !== "" && (
                  <div className="textBackground flex flex-column">
                    <div
                      className="textVisabilityButton align-center"
                      onClick={() => toggleText(index, "after")}
                    ></div>
                    {showTexts[index]?.after && (
                      <>
                        <div
                          className="textImages inter"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {c.text_after}
                        </div>
                        <div
                          className="textVisabilityButton align-center"
                          onClick={() => toggleText(index, "after")}
                        ></div>
                      </>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div
            className="flex flex-column justify-center noneMobile"
            style={{ gap: "1em", marginLeft: "0.5em" }}
          >
            <div
              className="roundedButton flex items-center"
              onClick={handleDownloadImages}
            >
              <span className="icon material-icons" title="Download: Bilder">
                download
              </span>
            </div>
            <div
              className="roundedButton flex items-center"
              onClick={handleDownloadAttachments}
            >
              <span className="icon material-icons" title="Download: Anhänge">
                archive
              </span>
            </div>
            {/*<div className="roundedButton flex items-center" onClick={handleShare}>
              <span className="icon material-icons" title="Teilen">share</span>
            </div>*/}
            <div
              className="roundedButton flex items-center"
              onClick={toggleMarkers}
            >
              <span
                className="icon material-icons"
                title="Sichtbarkeit: Kommentar-Marker"
              >
                grain
              </span>
            </div>
            <div
              className="roundedButton flex items-center"
              onClick={toggleFullscreen}
            >
              <span className="icon material-icons" title="Vollbild">
                fullscreen
              </span>
            </div>
            <div
              className="roundedButton flex items-center"
              onClick={() => {
                const firstImageId = content[0]?.id ?? 0;
                setClickData({ imageId: firstImageId, x: null, y: null });
                setPopupOpen(true);
              }}
            >
              <span
                className="icon material-icons"
                title="Kommentar ohne Marker hinzufügen"
              >
                add_comment
              </span>
            </div>
          </div>

          <div className="rightPart flex flex-column">
            <div className="commentsHeader noneMobile inter">
              <div style={{ borderBottom: "1px solid black" }}>
                <div
                  style={{
                    fontWeight: "400",
                    fontSize: "2em",
                    margin: "0 1em 0 1em",
                  }}
                  className="titleGradient"
                  onClick={toggleBeschreibung}
                >
                  Postbeschreibung
                </div>
                <div
                  style={{
                    margin: "1em 0 1em 2em",
                    display: beschreibungVisible ? "block" : "none",
                  }}
                  className="postbeschreibungInhalt"
                >
                  <div className="flex items-center space-between">
                    <span style={{ fontWeight: "600", fontSize: "1.3em" }}>
                      {post.title}
                    </span>
                    <div
                      className="flex items-center"
                      style={{ fontWeight: "400", fontSize: "0.8em" }}
                    >
                      <span>erstellt von</span>
                      <img
                        className="imgDetails"
                        style={{ margin: "0 0.3em 0 0.3em" }}
                        src={`/semesterprojekt/backend/uploads/profileImg/${post.profile_img}`}
                      />
                      <span style={{ fontWeight: "500", fontSize: "1em" }}>
                        {post.username}
                      </span>
                    </div>
                  </div>
                  <span className="postDescriptionDetails">
                    {post.description}
                  </span>
                </div>
              </div>
              {/*<div className="roundedComment flex items-center justify-center" 
              onClick={() => {
                const firstImageId = content[0]?.id ?? 0;
                setClickData({ imageId: firstImageId, x: null, y: null });
                setPopupOpen(true);
              }}>
                <span className="icon material-icons" title="Kommentar hinzufügen">add_comment</span>
              </div>*/}
            </div>
            <div
              style={{
                fontWeight: "400",
                fontSize: "2em",
                position: "sticky",
                margin: "0 1em 0 1em",
              }}
              className="titleGradient inter"
              onClick={toggleBeschreibung}
            >
              Kommentare
            </div>
            <div
              className="comments inter flex"
              style={{ justifyContent: "flex-end" }}
            >
              <div className="commentsFocus">
                <div className="commentsList">
                  {comments.map((comment) => (
                    <div
                      data-marker-id={`marker-${comment.comment_id}`}
                      key={comment.comment_id}
                      id={`comment-${comment.comment_id}`}
                      className="commentGesamt"
                      style={{ cursor: "pointer", position: "relative" }}
                      onClick={() => {
                        const marker = document.querySelector(
                          `[data-marker-id="marker-${comment.comment_id}"]`
                        );
                        if (
                          marker &&
                          showMarkers &&
                          comment.x > 0 &&
                          comment.y > 0
                        ) {
                          marker.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          });
                          marker.classList.add("marker-highlight");
                          setTimeout(() => {
                            marker.classList.remove("marker-highlight");
                          }, 2000);
                        }
                      }}
                    >
                      <div className="profile flex items-center">
                        <img
                          className="profileImg"
                          src={`/semesterprojekt/backend/uploads/profileImg/${comment.profile_img}`}
                        />

                        <span style={{ fontWeight: "400" }}>
                          {comment.username}
                        </span>
                        <span
                          style={{
                            fontWeight: "200",
                            fontSize: "0.8em",
                            marginLeft: "1em",
                          }}
                        >
                          {formatCommentDate(comment.created_at)}
                        </span>

                        {user?.userId === comment.user_id && (
                          <div
                            className="deleteCommentButton"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteComment(comment.comment_id);
                            }}
                          >
                            <span
                              className="icon material-icons"
                              title="Kommentar löschen"
                            >
                              delete_forever
                            </span>
                          </div>
                        )}
                      </div>

                      {comment.parts.map((part) => (
                        <div
                          key={part.commentpart_id}
                          className="comment inter"
                        >
                          <span style={{ fontWeight: "600" }}>
                            {part.title}
                          </span>
                          <br />
                          <span className="text">{part.text}</span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {user ? (
        <CommentPopup
          isOpen={popupOpen}
          onClose={() => setPopupOpen(false)}
          onSubmit={handleCommentSubmit}
          imageId={clickData.imageId}
          profile_img={user.profile_img}
          x={clickData.x}
          y={clickData.y}
        />
      ) : (
        popupOpen && navigateToLogin()
      )}
      {fullscreenOpen && (
        <div className="fullscreen-overlay">
          <div
            className="fullscreen-close"
            onClick={() => setFullscreenOpen(false)}
          >
            <span
              className="icon material-icons"
              title="Schließen"
              style={{ color: "white" }}
            >
              close
            </span>
          </div>
          <div className="fullscreen-content">
            {content.map((c, index) => (
              <div key={index} className="fullscreen-image-wrapper">
                <img
                  src={c.image_url}
                  alt={`fullscreen-${index}`}
                  className="fullscreen-image"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
